import React, { memo } from 'react';
import styles from './ZtTitle_V2.module.less';

// eslint-disable-next-line @typescript-eslint/naming-convention
const level_class = {
  1: 'card_title_1',
  2: 'card_title_2',
  3: 'card_title_3',
};
export default memo(({ data = {} }) => {
  const { type = 1 } = data;
  return data && data.content ? (
    <div className={styles.card}>
      <div
        className={styles[level_class[type || 1]]}
        style={data.attribute ? JSON.parse(data.attribute) : {}}
        dangerouslySetInnerHTML={{
          __html: data.content && data.content.title && data.content.title.replace(/\n/g, '</br>'),
        }}
      />
    </div>
  ) : (
    ''
  );
});
